// extracted by mini-css-extract-plugin
export var readonly = "_gd-1";
export var star = "_gd-0";